import React, {useState, useEffect} from "react";

const DesktopTabsForEnrolledStudents= ({setActiveTab, activeTab, CourseName}) => {
   
    return (
        <div className="hidden lg:flex w-full h-[280px] justify-center items-center 
           bg-[linear-gradient(91deg,_#B05BC5_0%,_#AEAEFD_100%)]"
            >
           <div className="w-[80%] h-fit flex flex-col gap-[70px] mt-[80px]">
                <p className="text-[45px] font-bold text-[#FFFFFF] mt-[20px]"> 
                    {CourseName?.courseName}
                </p>
                
                <div className="w-full flex gap-[90px] ">
                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                        onClick={() => setActiveTab("UpcomingClasses")}>
                            Upcoming classes
                        </p>
                        { activeTab === "UpcomingClasses" && (
                            <div className="h-[7px] bg-[#FFFFFF]">
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                        onClick={() => setActiveTab("Pickup")}>
                              Pickup
                        </p>
                        { activeTab === "Pickup" && (
                            <div className="h-[7px] bg-[#FFFFFF]">
                            </div>
                        )}
                    </div>

                    <div className="flex flex-col gap-[2px] cursor-pointer">
                        <p className={`text-[22px] font-semibold text-[#FFFFFF]`}
                        onClick={() => setActiveTab("PaymentSetting")}>
                              Payment Setting
                        </p>
                        { activeTab === "PaymentSetting" && (
                            <div className="h-[7px] bg-[#FFFFFF]">
                            </div>
                        )}
                    </div>
                </div>
           </div>
        </div>
    );
};

export default DesktopTabsForEnrolledStudents;
